import {useLocation} from 'react-router-dom';
import {reportTypeMap} from './config/reportTypes';
import {Suspense} from 'react';

const StandardReportContainer: React.FC = () => {
  const location = useLocation();
  const reportKey = location.pathname?.split('/')?.[2] ?? '';

  const ReportComponent = reportTypeMap?.[reportKey ?? ''];

  if (!ReportComponent) return <div data-testid={`standard-report-container-report-not-found`}>Report not found</div>;

  return (
    <Suspense fallback={<div data-testid={`standard-report-container-loading-report`}>Loading report...</div>}>
      <ReportComponent />
    </Suspense>
  );
};

export default StandardReportContainer;
